import { styled } from "styled-components";

interface InputStyledProps {
  width: string;
  height: number | string;
  fontSize?: string;
  background?: string;
}

export const InputStyled = styled.input<InputStyledProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height}px;
  font-size: ${(props) => props.fontSize || "20px"};
  background: ${(props) => props.background || "#72E27F"};

  border: 2px solid #355B94;
  font-weight: bold;
  color: #2c2c2c;
  padding: 5px;
  margin: 0;
  position: relative;
  top: 0px;
  &:focus {
    outline: none;
    border: 3px solid #77EC84;
  }
  &::placeholder {
    color: #2c2c2c90;
  }
`;
